var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 20V4H13V2H3C2.5 2 2 2.5 2 3V21C2 21.5 2.5 22 3 22H21C21.5 22 22 21.5 22 21V3C22 2.5 21.5 2 21 2H16V4L20 4V11H16V13H20V20H12V13H14V11H12V8H10V20H4Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }